import { type ReactElement, type SVGProps } from 'react';

export const SurfaceSalesIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 1.793 1.646 3.647l.708.707L3 3.707v13.086l-.646-.646-.708.707L3.5 18.708l1.854-1.854-.708-.707-.646.646V3.707l.646.647.708-.707L3.5 1.793ZM22.207 20.5l-1.853-1.854-.707.708.646.646H7.207l.647-.646-.708-.707L5.293 20.5l1.853 1.854.708-.707L7.207 21h13.086l-.646.646.707.708 1.854-1.854ZM20 17H8v-7h1v6h10v-6h1v7Zm-.917-15H8.917L7 7c0 1.105.964 2 2.154 2 .643 0 1.22-.262 1.615-.677.395.415.972.677 1.616.677.643 0 1.22-.262 1.615-.677.395.415.972.677 1.615.677.644 0 1.221-.262 1.616-.677.394.415.972.677 1.615.677C20.036 9 21 8.105 21 7l-1.917-5Zm-9.93 6c-.594 0-1.076-.448-1.076-1h2.154c0 .552-.482 1-1.077 1Zm3.232 0c-.595 0-1.077-.448-1.077-1h2.154c0 .552-.483 1-1.077 1Zm3.23 0c-.594 0-1.076-.448-1.076-1h2.153c0 .552-.482 1-1.077 1Zm3.231 0c-.595 0-1.077-.448-1.077-1h2.154c0 .552-.482 1-1.077 1ZM8.458 6.02l1.155-3.018h8.761l1.141 3.019H8.458Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
